import HttpRequest from "./http_request";

class ReportProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL);
  }

  async getStatisticSplitCurrYear() {
    const { data } = await this.get("/", {
      function: "get-statistic-split-curr-year",
    });
    return data;
  }

  async getStatisticSplitCurrCreatedDate(year) {
    const { data } = await this.get("/", {
      function: "get-statistic-split-curr-created-date",
      YEAR: year,
    });
    return data;
  }

  async getStatisticSplitCurr(year) {
    const { data } = await this.get("/", {
      function: "get-statistic-split-curr",
      YEAR: year,
    });
    return data;
  }

  async getReportStudentStudy(year, month) {
    const { data } = await this.get("/", {
      function: "get-report-student-study",
      YEAR: year,
      MONTH: month,
    });
    return data;
  }

  async getReportXStudentStudy(year, month, level) {
    const { data } = await this.get("/", {
      function: "get-report-x-student-study",
      YEAR: year,
      MONTH: month,
      LEVEL: level,
    });
    return data;
  }

  async getReportStudentDisability() {
    const { data } = await this.get("/", {
      function: "get-report-student-disability",
    });
    return data;
  }

  async getReportStudentIslam() {
    const { data } = await this.get("/", {
      function: "get-report-student-islam",
    });
    return data;
  }

  async getReportStudentInter() {
    const { data } = await this.get("/", {
      function: "get-report-student-inter",
    });
    return data;
  }

  async getReportStudentNotRegistered({level_id, faculty_id, year, semester}) {
    const { data } = await this.get("/", {
      function: "get-report-student-not-registered",
      level_id,
      faculty_id,
      year,
      semester,
    });
    return data;
  }

  async getStudentDebtReport({
    level_id,
    year,
    semester,
    faculty_id,
    department_id,
    curriculum_id,
    fund_mode,
  }) {
    const { data } = await this.get("/", {
      function: "get-student-debt-report",
      level_id,
      year,
      semester,
      faculty_id,
      department_id,
      curriculum_id,
      fund_mode,
    });
    return data;
  }

}

export default ReportProvider;
